import { Link } from "react-router-dom";
import { Figure } from "./Primitives";
import { Illu } from "./Illustrations";
import { Instagram, MapPin, ArrowRight } from "lucide-react";

export const Artist = ({ texts, image, mediaId }) => (
  <section id="rene" data-testid="artist-section" className="relative border-b border-paper-line ap-section">
    <div className="ap-container grid gap-10 lg:grid-cols-[0.84fr_1.16fr] lg:gap-14">
      <div className="relative">
        <span className="ap-stamp absolute -top-6 left-0 hidden lg:block">AP · STUDIO · 01</span>
        <div className="border border-ink/15 p-2">
          <Figure
            src={image}
            mediaId={mediaId}
            alt="René Ghavami tätowiert in seinem privaten Studio in St. Ruprecht an der Raab"
            ratio="aspect-[4/3]"
          />
        </div>
      </div>

      <div>
        <p className="ap-stamp">AP · PERSON</p>
        <h2 className="ap-h2 mt-4 text-ink">{texts.artist_h2}</h2>
        <p className="ap-lead mt-6">{texts.artist_body}</p>

        <div className="mt-8 flex items-start gap-3 border-l-2 border-signal pl-4">
          <MapPin size={18} className="mt-1 shrink-0 text-signal" />
          <div>
            <p className="font-display text-base font-bold uppercase tracking-wide text-ink">{texts.artist_region}</p>
            <p className="ap-body mt-1 text-charcoal">{texts.artist_note}</p>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href={texts.instagram_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="artist-instagram"
            className="ap-btn-ghost"
          >
            <Instagram size={16} /> {texts.instagram_handle}
          </a>
          <a href="#anfrage" data-testid="artist-cta" className="ap-btn-solid">
            Projekt anfragen <ArrowRight size={16} />
          </a>
        </div>

        <div className="mt-10 border border-paper-line bg-paper-surface/60 p-6" data-testid="discover-teaser">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="ap-stamp">AP · NEBENPROJEKT</p>
              <h3 className="ap-h3 mt-3 text-ink">{texts.discover_h3}</h3>
            </div>
            <div className="ap-illu hidden h-16 w-16 shrink-0 sm:block" aria-hidden="true">
              <Illu name={texts.illu_location} fallback="location" className="h-full w-full" />
            </div>
          </div>
          <p className="ap-body mt-3 text-charcoal">{texts.discover_body}</p>
          <Link to="/entdecken" data-testid="discover-cta" className="ap-btn-ghost mt-5">
            {texts.discover_cta} <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
